// src/redux/reducer/BulkOrderReducer.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: null,
  successResponse: null,
};

const BulkOrderReducer = createSlice({
  name: "BulkOrder",
  initialState,
  reducers: {
    submitBulkOrderRequest: (state) => {
      state.isLoading = true;
      state.error = null;
      state.successResponse = null;
    },
    submitBulkOrderSuccess: (state, action) => {
      state.isLoading = false;
      state.successResponse = action.payload;
    },
    submitBulkOrderFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    clearBulkOrderState: (state) => {
      state.isLoading = false;
      state.error = null;
      state.successResponse = null;
    },
  },
});

export const {
  submitBulkOrderRequest,
  submitBulkOrderSuccess,
  submitBulkOrderFailure,
  clearBulkOrderState,
} = BulkOrderReducer.actions;

export default BulkOrderReducer.reducer;
